/* necalli homepage behaviour — mirrors the wireframe's Component logic. Loaded only on the homepage. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(window.Shopify && window.Shopify.designMode);

  /* reveal: opacity 0 / y14 / scale .985 -> in, 1400ms, 150ms stagger (CSS) */
  function initReveal(root) {
    var els = root.querySelectorAll('.nc-reveal:not(.is-in)');
    if (!els.length) return;
    if (reduce || design || !('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* vertical library: hover/focus/tap opens; default panel; optional reset on leave */
  function initRail(rail) {
    if (rail.__nc) return; rail.__nc = true;
    var panels = Array.prototype.slice.call(rail.querySelectorAll('.nc-panel'));
    if (!panels.length) return;
    var def = rail.getAttribute('data-default');
    var byKey = function (k) { for (var i = 0; i < panels.length; i++) if (panels[i].getAttribute('data-key') === k) return panels[i]; return null; };
    var fallback = function () { return byKey(def) || panels[0]; };
    var set = function (p) { panels.forEach(function (x) { var on = x === p; x.classList.toggle('is-active', on); x.setAttribute('aria-expanded', on ? 'true' : 'false'); }); };
    set(fallback());
    panels.forEach(function (p) {
      p.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') set(p); });
      p.addEventListener('focusin', function () { set(p); });
      p.addEventListener('click', function (e) { if (!p.classList.contains('is-active')) { e.preventDefault(); set(p); } });
    });
    if (rail.getAttribute('data-reset-on-leave') === 'true') {
      rail.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') set(fallback()); });
    }
  }

  /* hero: cursor glow + acts shrink on scroll */
  var heroes = [];
  function initHero(hero) {
    if (hero.__nc) return; hero.__nc = true;
    heroes.push(hero);
    var glow = hero.querySelector('.nc-hero__glow');
    if (glow && !reduce) {
      var tx = 0, ty = 0, cx = 0, cy = 0, raf = null, lit = false;
      var tick = function () {
        cx += (tx - cx) * 0.09; cy += (ty - cy) * 0.09;
        glow.style.transform = 'translate3d(' + (cx - 380) + 'px,' + (cy - 380) + 'px,0)';
        if (Math.abs(tx - cx) > 0.4 || Math.abs(ty - cy) > 0.4) raf = requestAnimationFrame(tick); else raf = null;
      };
      hero.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse') return;
        var r = hero.getBoundingClientRect(); tx = e.clientX - r.left; ty = e.clientY - r.top;
        if (!lit) { lit = true; glow.style.opacity = '1'; }
        if (!raf) raf = requestAnimationFrame(tick);
      });
      hero.addEventListener('pointerleave', function () { lit = false; glow.style.opacity = '0'; });
    }
  }

  /* manifesto: image parallax + eyebrow rule */
  var manifestos = [];
  function initManifesto(m) {
    if (m.__nc) return; m.__nc = true; manifestos.push(m);
    if (design || reduce) { var r = m.querySelector('.nc-eyebrow__rule--anim'); if (r) r.classList.add('is-in'); }
  }

  /* "What is inside" toggle */
  function initInside(root) {
    root.querySelectorAll('[data-nc-inside-toggle]').forEach(function (btn) {
      if (btn.__nc) return; btn.__nc = true;
      var target = document.getElementById(btn.getAttribute('aria-controls'));
      if (!target) return;
      btn.addEventListener('click', function () {
        var open = target.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* scroll: acts scale, manifesto parallax, (future) nav hide */

  function onScroll() {
    var y = window.scrollY, vh = window.innerHeight;
    if (!reduce) heroes.forEach(function (h) {
      var acts = h.querySelector('.nc-acts');
      // design formula uses 2.2 viewports; on phones the block leaves the screen sooner, so ramp faster there
      var span = window.matchMedia && window.matchMedia('(max-width: 767px)').matches ? 1.2 : 2.2;
      if (acts) acts.style.transform = 'scale(' + Math.max(0.72, 1 - y / (vh * span)) + ')';
    });
    manifestos.forEach(function (m) {
      var wrap = m.querySelector('.nc-manifesto__media'); if (!wrap) return;
      var r = wrap.getBoundingClientRect();
      if (r.bottom > 0 && r.top < vh) {
        var p = (vh - r.top) / (vh + r.height);
        var img = m.querySelector('.nc-manifesto__img'); if (img && !reduce) img.style.transform = 'translateY(' + (-p * 14) + '%)';
        var rule = m.querySelector('.nc-eyebrow__rule--anim'); if (rule && p > 0.18) rule.classList.add('is-in');
      }
    });
  }

  /* click ripple (whole homepage, as in the wireframe) */
  function initRipple() {
    if (reduce || document.__ncRipple) return; document.__ncRipple = true;
    document.addEventListener('pointerdown', function (e) {
      var d = document.createElement('div'); d.className = 'nc-ripple';
      d.style.left = e.clientX + 'px'; d.style.top = e.clientY + 'px';
      document.body.appendChild(d);
      requestAnimationFrame(function () { d.classList.add('is-out'); });
      setTimeout(function () { if (d.parentNode) d.parentNode.removeChild(d); }, 1000);
    });
  }

  function init(root) {
    root = root || document;
    initReveal(root);
    root.querySelectorAll('[data-nc-rail]').forEach(initRail);
    root.querySelectorAll('[data-nc-hero]').forEach(initHero);
    root.querySelectorAll('[data-nc-manifesto]').forEach(initManifesto);
    initInside(root);
    onScroll();
  }

  function boot() {
    init();
    initRipple();
    window.addEventListener('scroll', onScroll, { passive: true });
    if (!reduce) document.documentElement.style.scrollBehavior = 'smooth';
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
